const monthsEnum = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const convertHour = (hour) => {
  const suffix = hour >= 12 ? "PM" : "AM";
  return { hour: ((hour + 11) % 12) + 1, suffix };
};

export const getStripeDate = (created) => {
  const date = new Date(created * 1000);
  const year = date.getFullYear();
  const month = monthsEnum[date.getMonth()];
  const day = date.getDate();
  const { hour, suffix } = convertHour(date.getHours());
  const minutes = date.getMinutes();
  return {
    year,
    month,
    day,
    hour,
    minutes,
    suffix,
    monthNumber: date.getMonth() + 1,
  };
};
